module.exports = __webpack_public_path__ + "static/media/SelfAwarnessOfValues.451725c1.mp3";